<template>
  <pt-detection-update class="pt-detection-update__withData"></pt-detection-update>
</template>

<script>
import PtDetectionUpdate from './index'
export default {
  name: 'pt-detection-update__withData',
  components: {
    'pt-detection-update': PtDetectionUpdate
  }
}
</script>
